import ertRadioButtonGroupComponent from './buttonGroup/radioButtonGroup.component';

const ertRadioButton = angular.module('app.common.ertRadioButton', [])
	.component('ertRadioButtonGroup', ertRadioButtonGroupComponent)
	.name;

export default ertRadioButton;
